import React, { useState, Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
const Header = React.lazy(() => import('./Header'))
const Sidebar = React.lazy(() => import('./Sidebar'))

export default function Layout() {
  const [menu, setMenu] = useState(false)
  const toggleMobileMenu = () => {
    setMenu(!menu)
  }

  const location = useLocation()
  const url = location?.pathname

  let urlCondition =
    url === '/online-payment' ||
    url === '/signature-preview-invoice' ||
    url === '/add-signature-preview-invoice' ||
    url === '/add-purchase-signature-preview' ||
    url === '/edit-purchase-signature-preview' ||
    url === '/edit-signature-preview-invoice' ||
    url.includes('/print-download-invoice/') ||
    url === '/mail-pay-invoice'
  return (
    <>
      <div className={`main-wrapper ${menu ? 'slide-nav' : ''}`}>
        <Suspense fallback={<div>Loading...</div>}>
          {!urlCondition && <Sidebar onMenuClick={() => toggleMobileMenu()} />}
          {!urlCondition && <Header onMenuClick={() => toggleMobileMenu()} />}
          <Outlet />
          {/* <div className='footer_main_div'>
              <p className='footer_text'>Copyright © 2024. Created with <label className='heart_color'>♥</label> by Sett Solutions</p>
          </div> */}
        </Suspense>
      </div>
    </>
  )
}
